export default class TiebreakerModel {
    public goldenGoal: number = null;
}